import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Field } from 'cccisd-formik';
import Modal from 'cccisd-modal';
import IconArrow from 'cccisd-icons/arrow-resize4';
import IconBin from 'cccisd-icons/bin';
import IconPencil from 'cccisd-icons/pencil';
import IconPlus from 'cccisd-icons/plus-circle';
import Tooltip from 'cccisd-tooltip';
import WidgetForm from './WidgetForm';
import { widgetBuilder } from 'cccisd-laravel-appdefs';
import style from './style.css';

export const initialValues = {
    widgetList: [],
};

const DynamicWidgetListBuilder = () => {
    const handleDelete = (id, form) => {
        form.setFieldValue(
            'widgetList',
            form.values.widgetList.filter(widg => widg.id !== id)
        );
    };

    const onDragEnd = (event, form) => {
        const {
            destination: { index: toIndex },
            source: { index: fromIndex },
        } = event;

        let newValues = [];
        const targetValue = form.values.widgetList[fromIndex];
        const filteredValues = form.values.widgetList.filter((v, i) => i !== fromIndex);
        for (let i = 0; i < form.values.widgetList.length; i++) {
            if (i < toIndex) {
                newValues.push(filteredValues[i]);
            } else if (i === toIndex) {
                newValues.push(targetValue);
            } else {
                newValues.push(filteredValues[i - 1]);
            }
        }

        form.setFieldValue('widgetList', newValues);
    };

    const renderDraggable = (widget, i, form) => (
        <Draggable draggableId={'' + widget.id} index={i} key={widget.id}>
            {provided => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={style.draggable}
                >
                    <span>
                        <IconArrow />
                        <h6 className={style.typeText}>{widget.typeText}</h6>
                        {widget.type === 'variable' && <span>- {widget.variable.reportHeader}</span>}
                        {widget.type === 'dragdrop' && <span>- {widget.dragDropEntityId}</span>}
                    </span>
                    <span>
                        <Modal
                            title={`Edit: Widget ${i + 1}`}
                            trigger={
                                <Tooltip title="Edit">
                                    <button type="button" className={'btn btn-xs btn-success ' + style.editBtn}>
                                        <IconPencil />
                                    </button>
                                </Tooltip>
                            }
                            render={({ closeModal }) => (
                                <WidgetForm form={form} closeModal={closeModal} initialWidget={widget} />
                            )}
                        />
                        <Tooltip title="Delete">
                            <button
                                type="button"
                                className="btn btn-xs btn-danger"
                                onClick={() => handleDelete(widget.id, form)}
                            >
                                <IconBin />
                            </button>
                        </Tooltip>
                    </span>
                </div>
            )}
        </Draggable>
    );

    const renderDragDrop = (field, form) => (
        <DragDropContext onDragEnd={event => onDragEnd(event, form)}>
            <Droppable droppableId="widgets_list">
                {dropProvided => (
                    <div ref={dropProvided.innerRef} className={style.droppable}>
                        {field.value.length === 0 && (
                            <p className={'help-block ' + style.helpBlock}>No widgets have been added yet.</p>
                        )}
                        {field.value.map((widg, i) => renderDraggable(widg, i, form))}
                        {dropProvided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );

    return (
        <Field name="widgetList">
            {({ field, form }) => (
                <>
                    {renderDragDrop(field, form)}
                    <Modal
                        title="Add Widget"
                        trigger={
                            <button type="button" className="btn btn-default">
                                <IconPlus />
                                &nbsp;&nbsp;Add Widget
                            </button>
                        }
                        render={({ closeModal }) => <WidgetForm form={form} closeModal={closeModal} />}
                        size="670px"
                    />
                </>
            )}
        </Field>
    );
};

export default widgetBuilder({ initialValues })(DynamicWidgetListBuilder);
